export default __webpack_public_path__ + "static/media/close-icon.ebd9b8e6.svg";